module.exports = __webpack_public_path__ + "img/1.14a4e50e.png";